import React from 'react';
import { Search, ShoppingCart, TrendingUp, Receipt, Calculator, Wallet, Trash2 } from 'lucide-react';
import StatCard from '../../components/Cards/StatCard';
import TaxBox from '../../components/Cards/TaxBox';

function DashboardTab({
  globalSearch, setGlobalSearch, globalResults, setSelectedItem,
  stats, isBulkSelling, quickSellCode, setQuickSellCode, handleQuickSell,
  selectedYear, selectedMonth, handleClearData
}) {
  const monthNames = ["", "Yanvar", "Fevral", "Mart", "Aprel", "May", "Iyun", "Iyul", "Avgust", "Sentabr", "Oktyabr", "Noyabr", "Dekabr"];
  const periodLabel = `${monthNames[selectedMonth]} ${selectedYear}`;

  return (
    <div className="space-y-8 animate-in">
      <div className="flex justify-between items-end">
        <div className="flex-1 mr-6">
          <p className="text-[10px] font-black text-blue-500 uppercase tracking-[0.3em] mb-2 ml-1">Ma'lumotlar 2026-yildan boshlab</p>
          <div className="relative">
            <Search className="absolute left-6 top-1/2 -translate-y-1/2 text-blue-400/50" size={24}/>
            <input
              type="text"
              placeholder="Global qidiruv (Nom yoki Kod)..."
              className="w-full pl-16 pr-6 py-6 bg-slate-900 border border-blue-500/20 rounded-[30px] shadow-[0_0_30px_rgba(0,0,0,0.3)] outline-none focus:border-blue-400/50 focus:ring-2 focus:ring-blue-500/10 font-bold text-lg text-white"
              value={globalSearch}
              onChange={e => setGlobalSearch(e.target.value)}
            />
          </div>
        </div>

        <button
          onClick={handleClearData}
          className="flex items-center gap-2 px-6 py-6 bg-rose-500/10 border border-rose-500/20 text-rose-500 rounded-[30px] font-black hover:bg-rose-500 hover:text-white transition-all shadow-lg active:scale-95 text-sm uppercase tracking-widest"
        >
          <Trash2 size={20} /> Baza Tozalash
        </button>
      </div>

      <div className="relative">
        <div className="flex gap-6">
          <div className="relative flex-1">
             {/* Search was here, moved up */}
          </div>

          <div className="relative w-1/3">
            <ShoppingCart className={`absolute left-6 top-1/2 -translate-y-1/2 ${isBulkSelling ? 'text-emerald-400 animate-bounce' : 'text-emerald-400/50'}`} size={24}/>
            <input
              type="text"
              placeholder={isBulkSelling ? "Sotilmoqda..." : "OMMOVAY SOTUV (Kodlarni tashlang)..."}
              disabled={isBulkSelling}
              className="w-full pl-16 pr-6 py-6 bg-slate-950 border-2 border-emerald-500/20 rounded-[30px] shadow-[0_0_20px_rgba(16,185,129,0.1)] outline-none focus:border-emerald-400/50 font-bold text-white placeholder-emerald-900"
              value={quickSellCode}
              onChange={e => setQuickSellCode(e.target.value)}
              onKeyDown={handleQuickSell}
            />
          </div>
        </div>

        {globalSearch.length > 2 && (
          <div className="absolute top-full left-0 right-0 mt-4 bg-slate-900 rounded-[30px] shadow-2xl border border-blue-500/20 z-50 max-h-96 overflow-y-auto p-4 backdrop-blur-xl">
             {globalResults.length === 0 ? <p className="p-10 text-center text-slate-500 font-bold">Hech narsa topilmadi</p> :
              globalResults.map((i,idx) => (
                <div key={idx} onClick={() => setSelectedItem(i)} className="flex items-center gap-4 p-4 hover:bg-blue-600/10 rounded-2xl cursor-pointer border-b last:border-0 border-white/5 transition-all">
                  <div className={`w-3 h-3 rounded-full shadow-[0_0_10px] ${i.status === 'in_stock' ? 'bg-emerald-500 shadow-emerald-500/50' : 'bg-rose-500 shadow-rose-500/50'}`}/>
                  <div className="flex-1">
                    <p className="font-black text-slate-100">{i.product_name}</p>
                    <p className="text-[10px] text-slate-500 font-mono">{i.marking_code}</p>
                  </div>
                  <div className="text-right">
                    <p className="font-black text-blue-400">{Math.round(i.cost_price).toLocaleString()} s</p>
                    <p className={`text-[10px] font-black uppercase ${i.status === 'in_stock' ? 'text-emerald-400' : 'text-rose-400'}`}>{i.status === 'in_stock' ? 'Omborda' : 'Sotilgan'}</p>
                  </div>
                </div>
              ))
             }
          </div>
        )}
      </div>

      <div className="grid grid-cols-4 gap-6">
        <StatCard title="Omborda" value={Number(stats.total_in_stock || 0)} color="blue" />
        <StatCard title="Sotilgan" value={Number(stats.total_sold || 0)} color="rose" />
        <StatCard title="Ombor Qiymati" value={Math.round(stats.inventory_value || 0).toLocaleString()} unit="s" color="orange" />
        <div className="bg-slate-900 p-6 rounded-[40px] border border-indigo-500/20 shadow-2xl flex flex-col justify-center items-center">
            <p className="text-[10px] font-black text-indigo-400 uppercase tracking-widest mb-1">Ma'lumot Aniqligi</p>
            <div className="text-3xl font-black text-white flex items-baseline gap-1">
                {stats.total_sold > 0 ? Math.round(((stats.total_sold - (stats.total_errors || 0)) / stats.total_sold) * 100) : 100}
                <span className="text-sm text-indigo-500">%</span>
            </div>
            <p className="text-[9px] text-slate-500 font-bold mt-1 text-center">Asil Belgi bilan sinxron</p>
        </div>
      </div>

      <div className="bg-slate-900 p-8 rounded-[40px] border border-blue-500/10 shadow-[0_0_50px_rgba(0,0,0,0.2)]">
        <h3 className="text-xl font-black mb-6 flex items-center gap-2 text-white">
          <TrendingUp size={24} className="text-blue-400"/>
          Oylik Foyda Monitoringi <span className="text-slate-500 text-sm font-bold ml-2">({periodLabel})</span>
        </h3>
        <div className="flex justify-center">
           <TaxBox title="Oy Yakuniy Foydasi" value={Math.round(stats.period_gross_profit || 0).toLocaleString()} icon={<TrendingUp/>} color="emerald" />
        </div>
      </div>
    </div>
  );
}

export default DashboardTab;
